import React from 'react';
/**
 * Hidden SVG containing the riam gold gradient definitions.
 * Reference in any icon via stroke="url(#riamGold)" or fill="url(#riamGoldFill)".
 */
export function GoldGradient() {
  return <svg width="0" height="0" style={{
    position: 'absolute'
  }} aria-hidden="true" data-id="element-323">
      <defs data-id="element-324">
        <linearGradient id="riamGold" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-325">
          <stop offset="0%" stopColor="#8a6d3b" data-id="element-326" />
          <stop offset="25%" stopColor="#c9a26a" data-id="element-327" />
          <stop offset="50%" stopColor="#f0d894" data-id="element-328" />
          <stop offset="75%" stopColor="#c9a26a" data-id="element-329" />
          <stop offset="100%" stopColor="#8a6d3b" data-id="element-330" />
        </linearGradient>
        <linearGradient id="riamGoldFill" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-331">
          <stop offset="0%" stopColor="#8a6d3b" data-id="element-332" />
          <stop offset="50%" stopColor="#f0d894" data-id="element-333" />
          <stop offset="100%" stopColor="#8a6d3b" data-id="element-334" />
        </linearGradient>
      </defs>
    </svg>;
}